<template>
  <div class="settings__top-content">
    <p class="trustName">{{ $store.state.org.name }}</p>
    <transition name="fadeQuick" mode="out-in">
      <div class="walletInitial uppercase" v-if="initialShowCondition && $store.state.walletConnect.user.displayAddress">{{ $store.state.walletConnect.user.displayAddress.charAt(0) }}</div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'SettingsTop',
  components: {
  },
  data() {
    return {
    }
  },
  props: ['initialShowCondition'],
  computed: {
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>
